import { FormatHelper } from '../../helpers/FormatHelper';
import { OrderForListing } from '../../models/OrderForListing';
import { InformationPopover } from './InformationPopover';

interface IClientDeadlineCellProps {
  orderForListing: OrderForListing;
  clientDeadline: string;
}

export const ClientDeadlineCell: React.FC<IClientDeadlineCellProps> = ({
  orderForListing,
  clientDeadline
}) => {

return <>
    <span>{clientDeadline}</span>
    <InformationPopover text={FormatHelper.formatDate(orderForListing?.order?.currentDeliveryDeadlineDate)} />
  </>;
}